import React from 'react';
import { CustomExportRunStatus } from '@ydistri/api-sdk';
import { Tooltip } from 'antd';
import { MdOutlineUpload } from 'react-icons/md';
import { styled } from 'styled-components';
import { computeRemSize } from '@ydistri/theme';
import { CUSTOM_EXPORT_STATUS_CONFIG } from '../../../CalculationDetail/CustomExport/customExportLib';
import { Text } from '@ydistri/ds';

const CustomExportIndicatorWrapper = styled.div<{
  $backgroundColor: string;
  $textColor: string;
  $compact?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid ${p => p.$textColor};
  border-radius: 4px;
  padding: ${p => (p.$compact ? '0.15rem 0.45rem' : '0.25rem 0.6rem')};
  background-color: ${p => p.$backgroundColor};
  color: ${p => p.$textColor};
  font-size: ${p => (p.$compact ? '0.75rem' : '0.8125rem')};
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
`;

interface CustomExportIndicatorProps {
  status: CustomExportRunStatus;
  compact?: boolean;
}

const CustomExportIndicator: React.FC<CustomExportIndicatorProps> = ({ status, compact }) => {
  const config = CUSTOM_EXPORT_STATUS_CONFIG[status];

  return (
    <Tooltip title={`Export status: ${config.label}`}>
      <CustomExportIndicatorWrapper
        data-type="indicator-custom-export"
        $backgroundColor={config.backgroundColor}
        $textColor={config.color}
        $compact={compact}
      >
        <MdOutlineUpload size={computeRemSize(compact ? 14 : 16)} />
        <Text>{config.label}</Text>
      </CustomExportIndicatorWrapper>
    </Tooltip>
  );
};

export default CustomExportIndicator;
